<template>
  <div>
    <b-card
      class="custom-card filters mb-5 bg-light-success text-success "
      no-body
    >
      <b-card-body class="py-1">
        <div class="row">
          <b-col>
            <h4>Level</h4>
            <b-select
              :options="levels"
              text-field="name"
              value-field="_id"
              v-model="filter.level"
            >
              <template slot="first">
                <option value="">All Levels</option>
              </template>
            </b-select>
          </b-col>
          <b-col>
            <h4>Profile</h4>
            <b-select
              :options="profiles"
              text-field="name"
              value-field="_id"
              v-model="filter.profile"
            >
              <template slot="first">
                <option value="">All Profiles</option>
              </template>
            </b-select>
          </b-col>
        </div>
      </b-card-body>
    </b-card>

    <div v-for="project in filteredProjects" :key="project._id">
      <b-card
        class="card-custom gutter-b "
        no-body
        :class="{ 'bg-light-warning': isLive(project) }"
      >
        <b-card-body class="d-grid">
          <div
            class="imatge relative d-flex justify-content-start align-content-center"
            :style="
              project.image
                ? 'background-image: url(https://api.xupxup.net/' +
                  project.image +
                  ')'
                : 'background-image: url(/media/error/bg6.jpg)'
            "
          >
            <div
              class="tipology align-self-end justify-content-start mb-4 ml-4"
              v-if="project.sections.length == 0"
            >
              <span
                class="label label-xl label-dark text-white rounded label-inline font-weight-bolder"
              >
                <div v-if="project.numberOfUsers > 1">
                  <b-icon-people-fill class="mr-2"></b-icon-people-fill> Team
                </div>
                <div v-else>
                  <b-icon-person-fill class="mr-2"></b-icon-person-fill> Student
                </div>
              </span>
            </div>
            <div
              class="level label label-xl label-inline label-dark text-white font-weight-bolder"
            >
              <b-icon-award-fill class="mr-2"></b-icon-award-fill>
              <span class="">{{ detailLevel(project.level, "name") }}</span>
            </div>
            <div
              class="estimatedTime label label-xl label-inline label-dark text-white font-weight-bolder"
              v-if="project.estimatedTime"
            >
              <b-icon-clock-fill class="mr-2"></b-icon-clock-fill>
              <span class="">{{ project.estimatedTime }} h</span>
            </div>
            <div
              class="estimatedTime label label-xl label-inline label-dark text-white font-weight-bolder"
              v-else
            >
              <b-icon-clock class="mr-2"></b-icon-clock>
              <span class=" ">{{ calculateTime(project) }} h</span>
            </div>
          </div>

          <div
            class="info px-5 border-light-secondary d-flex flex-column justify-content-between"
          >
            <div class="d-flex flex-column mr-auto mt-4">
              <router-link :to="'/projects/' + project._id">
                <h2
                  href="#"
                  class="card-title text-hover-primary font-weight-bolder  text-dark mb-1"
                >
                  {{ project.title }}
                </h2>
              </router-link>
            </div>
            <div class="description" v-html="project.description"></div>
            <div>
              <div class="mt-3 d-flex flex-wrap">
                <TagsPills
                  :tagId="tag"
                  v-for="tag in project.tags"
                  :key="tag._id"
                />
              </div>
              <ProfilesBar :project="project"></ProfilesBar>
            </div>
          </div>
          <div class="sections" v-if="project.sections.length > 0">
            <div
              class="d-flex flex-wrap align-items-center p-3 mb-2 rounded"
              v-for="(section, index) in projects.filter(p =>
                project.sections.includes(p._id)
              )"
              :class="{
                'bg-secondary': isFinished(section)
                //'border-light-warning border': isLive(section)
              }"
              :key="index"
            >
              <!--begin::Symbol-->
              <div
                class="symbol symbol-60 symbol-2by3 flex-shrink-0 mr-4 d-none d-md-block d-lg-none d-xl-block"
                style="width:23%"
              >
                <div
                  class="relative symbol-label"
                  :style="
                    'background-image: url(https://api.xupxup.net/' +
                      section.image +
                      ')'
                  "
                >
                  <div class="tipology">
                    <span
                      class="label label-sm label-dark text-white rounded-circle"
                    >
                      <b-icon-people-fill
                        v-if="section.numberOfUsers > 1"
                      ></b-icon-people-fill
                      ><b-icon-person-fill v-else></b-icon-person-fill
                    ></span>
                  </div>
                </div>
              </div>
              <!--end::Symbol-->
              <!--begin::Title-->
              <div
                class="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2 "
                style="width:54%"
              >
                <a
                  href="#"
                  class="title text-dark-75 font-weight-bold text-hover-primary font-size-lg mb-1"
                  >{{ section.title }}</a
                >
                <span class="text-muted font-weight-bold">
                  <span class="points" v-for="p in section.points" :key="p._id">
                    <span class=" ">
                      <IconProfile :profileId="p.profile"></IconProfile>
                      {{ p.points }}</span
                    >
                    <br />
                  </span>
                  <!-- <TagsPills
                      :tagId="tag"
                      v-for="tag in section.tags"
                      :key="tag._id"
                  /> -->
                </span>
              </div>
              <!--end::Title-->
              <!--begin::Section-->
              <div class="d-flex align-items-center mt-lg-0 mt-3">
                <!--begin::Label-->
                <div class="mr-1" v-if="isFinished(section)">
                  <i class="fa fa-star mr-1 text-warning font-size-lg"></i>
                  <span class="text-dark-75 font-weight-bolder">{{
                    isFinished(section).stars
                  }}</span>
                </div>
                <div class="mr-1" v-else-if="isLive(section)">
                  <i
                    class="fa fa-star text-warning  mr-1 text-light-secondary font-size-lg"
                  ></i>
                  <span class="text-warning font-weight-bolder py-1 ">
                    LIVE
                  </span>
                </div>
                <div v-else class="mr-1">
                  <i
                    class="fa fa-star mr-1 text-light-secondary font-size-lg"
                  ></i>
                  <span class=" font-weight-bolder text-light-secondary"
                    >0</span
                  >
                </div>

                <!--end::Label-->
              </div>
              <!--end::Section-->
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.d-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 20px;
}
.info {
  border-right: 1px solid;
  .description {
    min-height: 100px;
    *:not(:nth-child(0)) {
      display: none;
    }
  }
}
.imatge {
  background-size: cover;
  background-position: center center;
}
.estimatedTime {
  position: absolute;
  top: 10px;
  right: 10px;
}
.level {
  position: absolute;
  top: 10px;
  left: 10px;
}
.card.card-custom > .card-body {
  padding: 1.8rem;
}

.points span {
  margin-right: 5px;
}

.points span i {
  margin-right: 4px;
  width: 20px;
}

.seccions .projecte {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  background-color: rgba(0, 0, 0, 0.02);
}
h3,
.title {
  text-overflow: ellipsis;
  // white-space: nowrap;
  // overflow: hidden;
}
.relative {
  position: relative;
  img {
    //  filter: grayscale(1);
  }
}
.no-active {
  //filter: grayscale(1);
  background-color: rgba(0, 0, 0, 0.07) !important;
  i,
  a {
    color: rgba(0, 0, 0, 0.1) !important;
  }
}
</style>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TagsPills from "@/view/layout/dashboard/TagsPills";
import ProfilesBar from "@/view/layout/dashboard/ProfilesBar";
import IconProfile from "@/view/layout/dashboard/IconProfile";
//import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "projects",
  components: { TagsPills, IconProfile, ProfilesBar },
  data() {
    return {
      hover: false,
      filter: {}
      //projects: [],
      //instances: []
    };
  },
  beforeMount() {
    // axios.get("users/me?fields=instances-instances-project, instances-project").then(response => {
    // 	let user = response.data;
    // 	let instances = response.data.instances;
    // 	this.instances = instances.filter(i => i.project.hasParent == false);
    // 	console.log("instances", this.instances);
    // 	axios
    // 	   .get(
    // 		 "projects?fields=level,points.profile,tags,instances,sections"
    // 	   )
    // 	   .then(response => {
    // 		   let projects = response.data;
    // 		   console.log("projects", projects);
    // 		   this.projects = projects.filter(p => !p.instances.filter(i => i.users.includes(user._id)).length > 0)
    // 		   console.log(this.projects)
    // 	   });
    // });
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Projects" }]);
    console.log("filter", this.filter);
  },
  methods: {
    checkPoints(project, profile) {
      if (project.points.length > 0) {
        let punts = project.points.find(p => p.profile == profile);
        return punts ? punts.points : 0;
      } else {
        let total = 0;
        project.sections.forEach(section => {
          let sectionFull = this.projects.find(p => p._id == section);
          let punts = sectionFull.points.find(p => p.profile == profile);

          total = total + (punts ? punts?.points : 0);
        });
        return total;
      }
    },
    isFinished(s) {
      console.log(
        "finished sections",
        this.instances.find(i => i.project == s._id && i.dateFinished)
      );
      return this.instances.find(i => i.project == s._id && i.dateFinished);
    },
    isLive(s) {
      console.log(
        "live sections",
        this.instances.find(i => i.project == s._id && !i.dateFinished)
      );
      return this.instances.find(i => i.project == s._id && !i.dateFinished);
    },
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    calculatePoints(project) {
      let total = 0;
      project.sections.forEach(section => {
        let sectionFull = this.projects.find(p => p._id == section);
        console.log("sectionFull", section, sectionFull);
        total =
          total + sectionFull.points.reduce((accum, s) => accum + s.points, 0);
      });
      console.log({ total });
      return total;
    },
    calculateTime(project) {
      let projectFull = this.projects.find(p => p._id == project._id);
      console.log({ projectFull });
      return projectFull.sections.reduce(
        (accum, s) => accum + this.projects.find(p => p._id == s).estimatedTime,
        0
      );
    },
    detailProfile(profile, field) {
      let p = this.profiles.find(prof => prof._id == profile);
      return p?.[field];
    },
    detailLevel(level, field) {
      let l = this.levels.find(lvl => lvl._id == level);
      return l?.[field];
    }
  },
  computed: {
    instances() {
      return this.$store.getters.getMyInstances;
    },
    projects() {
      console.log("projects", this.$store.getters.getProjects);
      return this.$store.getters.getProjects;
    },
    filteredProjects() {
 
      return this.projects.filter(
        p =>
          p.isActive === true &&
          p.hasParent === false &&
          (this.filter.level ? p.level == this.filter.level : 1) &&
          (this.filter.profile ? this.checkPoints(p, this.filter.profile) : 1)
      );
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    ...mapGetters(["currentUser", "breadcrumbs", "pageTitle", "layoutConfig"])

    // instancesUser() {
    //   return this.instances.filter(
    //     i =>
    //       i.users.find(u => u._id == this.currentUser.user.userId) &&
    //       i.project.hasParent == false
    //   );
    // },
    // projectsUser() {
    //   return this.projects.forEach(p =>
    //     p.instances.forEach(i =>
    //       i.users.find(u => u._id != this.currentUser.user.userId)
    //     )
    //   );
    // return this.projects.instances.filter(i =>
    //   i.users.find(u => u._id != this.currentUser.user.userId)
    // );
  }
};
</script>
